export default __webpack_public_path__ + "static/char-s-57-ko-782e47366db8fd6452eb7baca4629fbf.webp";